import axios from "axios";

export default {
  async getAteliers(idFormation) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/ateliers/formation/" +
        idFormation
    );
    return response.data;
  },
  async getAteliersByReferentSuaio() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/gestion/ateliers"
    );
    return response.data;
  },
  async getAtelier(id) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/ateliers/" + id
    );
    return response.data;
  },
  async addAtelier(atelier) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/ateliers",
      atelier
    );
    return response.data;
  },
  async updateAtelier(id, atelier) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL + "/api/ateliers/" + id,
      atelier
    );
    return response.data;
  },
  async deleteAtelier(id) {
    const response = await axios.delete(
      process.env.VUE_APP_BACKEND_API_URL + "/api/ateliers/" + id
    );
    return response.data;
  },
  async getAteliersByAnimateur() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/suaio/ateliers"
    );
    return response.data;
  },
  async getCsvFile(critere, id) {
    const url =
      process.env.VUE_APP_BACKEND_API_URL +
      `/api/gestion/ateliers/csv/${critere}/${id}`;
    const response = await axios.get(url);
    return response.data;
  }
};
